import { createGlobalStyle } from 'styled-components';
import { isAdminSite } from '@mindtickle/utils';
import { getBerryWidgetStyle } from '@mindtickle/ui-shell-core/Berry';
import { getFreshchatWidgetStyle } from '@mindtickle/ui-shell-core/Freshchat';

export const ShellGlobalStyle: any = createGlobalStyle`
  ${({ featureToggles = {} }: { featureToggles: any }) =>
    !featureToggles?.isBerryChatDisabled && getBerryWidgetStyle(isAdminSite())};

  /* TODO(tech-debt) - Adding this here as we are not making any changes in ui-shell-core due to snag-error */
  /* Once we fix ui-shell-core issue, we can move this css back to getBerryWidgetStyle function */
  ${({ featureToggles = {} }: { featureToggles: any }) =>
    !featureToggles?.isBerryChatDisabled &&
    `#BerryappChatWidget iframe {
        max-height: calc(100% - 170px) !important; 
        height: 636px;
    }`};
  
  ${({ featureToggles = {} }: { featureToggles: any }) =>
    !featureToggles?.isBerryChatDisabled && isAdminSite() && getFreshchatWidgetStyle()};
`;
